module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAgMEM0LjUgMCAwIDQuNSAwIDEwQzAgMTUuNSA0LjUgMjAgMTAgMjBDMTUuNSAyMCAyMCAxNS41IDIwIDEwQzIwIDQuNSAxNS41IDAgMTAgMFpNMTAgMThDNS42IDE4IDIgMTQuNCAyIDEwQzIgNS42IDUuNiAyIDEwIDJDMTQuNCAyIDE4IDUuNiAxOCAxMEMxOCAxNC40IDE0LjQgMTggMTAgMThaIiBmaWxsPSIjMzMzMzMzIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/choice-normal.svg
// module id = 741
// module chunks = 8